import React, { useState } from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
  Grid,
  Chip,
} from "@mui/material";

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  alpha,
} from "@mui/material";
import { lighten } from "@mui/material/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUp";

// Subject Icons
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import CalculateIcon from "@mui/icons-material/Calculate";
import TranslateIcon from "@mui/icons-material/Translate";

import PublicIcon from "@mui/icons-material/Public";
import getListStyles from "./listStyles";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import PsychologyIcon from "@mui/icons-material/Psychology";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import BrushIcon from "@mui/icons-material/Brush";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import BusinessIcon from "@mui/icons-material/Business";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import ChurchIcon from "@mui/icons-material/Church";
import ScienceIcon from "@mui/icons-material/Science";
import WaveIcon from "@mui/icons-material/Waves";
import BiotechIcon from "@mui/icons-material/Biotech";
import ForestIcon from "@mui/icons-material/Forest";
import TerrainIcon from "@mui/icons-material/Terrain";
import SoupKitchenIcon from "@mui/icons-material/SoupKitchen";

import HandymanIcon from "@mui/icons-material/Handyman";
const subjects = [
  { name: "Svenska", icon: <AutoStoriesIcon /> },

  { name: "Engelska", icon: <TranslateIcon /> },
  { name: "Matematik", icon: <CalculateIcon /> },

  { name: "Geografi", icon: <TerrainIcon /> },
  { name: "Historia", icon: <HistoryEduIcon /> },
  { name: "Religionskunskap", icon: <ChurchIcon /> },
  { name: "Samhällskunskap", icon: <PublicIcon /> },

  { name: "Biologi", icon: <BiotechIcon /> },
  { name: "Fysik", icon: <WaveIcon /> },
  { name: "Kemi", icon: <ScienceIcon /> },
  { name: "Teknik", icon: <BiotechIcon /> },

  { name: "Bild", icon: <BrushIcon /> },
  { name: "Hem- och konsumentkunskap", icon: <SoupKitchenIcon /> },
  { name: "Idrott och hälsa", icon: <SportsSoccerIcon /> },
  { name: "Musik", icon: <MusicNoteIcon /> },
  { name: "Slöjd", icon: <HandymanIcon /> },
];

const gradeGroups = [
  "1-3",
  "4-6",
  "7-9",
  "Gymnasiet",
  "Nationella provet",
  "Påsk",
];

const commonTags = [
  "Människor",
  "Djur",
  "Jul",
  "Påsk",
  "Alla hjärtans dag",
  "Mat",
  "Sport",
  "Miljö",
  "Musik",
  "Mytologi",
  "Sagor",
  "Dixit",
  "Fylla i bilder",
];
export const ImageTagsList = ({
  selectedTags,
  setSelectedTags,

  theme,
}) => {
  const { listItemStyles, listItemIconStyles, listItemTextStyles } =
    getListStyles(theme, theme.palette.mode === "dark");
  const [showAllTags, setShowAllTags] = useState(false);
  const visibleTags = showAllTags ? commonTags : commonTags.slice(0, 10);

  return (
    <List>
      <ListItem
        button
        selected={selectedTags.length === 0}
        onClick={() => setSelectedTags([])}
        sx={{ ...listItemStyles }}
      >
        <ListItemIcon sx={listItemIconStyles}>
          {selectedTags.length === 0 ? (
            <CheckCircleIcon
              sx={{ color: lighten(theme.palette.success.main, 0.2) }}
            />
          ) : (
            <RadioButtonUncheckedIcon />
          )}
        </ListItemIcon>
        <ListItemText primary="Senaste" sx={listItemTextStyles} />
      </ListItem>

      {visibleTags.map((tag) => (
        <ListItem
          button
          key={tag}
          selected={selectedTags.includes(tag)}
          onClick={() => {
            setSelectedTags((prev) => {
              if (prev.includes(tag)) {
                return prev.filter((t) => t !== tag);
              } else {
                return [...prev, tag];
              }
            });
          }}
          sx={{ ...listItemStyles }}
        >
          <ListItemIcon sx={listItemIconStyles}>
            {selectedTags.includes(tag) ? (
              <CheckCircleIcon sx={{ color: "success.main" }} />
            ) : (
              <RadioButtonUncheckedIcon />
            )}
          </ListItemIcon>
          <ListItemText primary={tag} sx={listItemTextStyles} />
        </ListItem>
      ))}

      {commonTags.length > 10 && (
        <ListItem
          button
          onClick={() => setShowAllTags(!showAllTags)}
          sx={{
            ...listItemStyles,
            color: "#94a3b8",
          }}
        >
          <ListItemIcon sx={listItemIconStyles}>
            <MoreHorizIcon sx={{ color: "#94a3b8" }} />
          </ListItemIcon>
          <ListItemText
            primary={showAllTags ? "Visa färre" : "Visa mer"}
            sx={{
              ...listItemTextStyles,
              "& .MuiTypography-root": {
                ...listItemTextStyles["& .MuiTypography-root"],
                color: "#94a3b8",
              },
            }}
          />
        </ListItem>
      )}
    </List>
  );
};

export const SubjectsList = ({
  selectedSubject,
  setSelectedSubject,
  selectedSubjects,
  setSelectedSubjects,
  setIsLoading,

  theme,
  compact = false,
}) => {
  const { listItemStyles, listItemIconStyles, listItemTextStyles } =
    getListStyles(theme, theme.palette.mode === "dark");
  const [showAllSubjects, setShowAllSubjects] = useState(false);

  const visibleSubjects = showAllSubjects ? subjects : subjects.slice(0, 10);

  if (compact) {
    return (
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Ämnen</InputLabel>
        <Select
          multiple
          value={selectedSubjects}
          onChange={(e) => {
            setIsLoading(true);
            setSelectedSubjects(e.target.value);
            setTimeout(() => setIsLoading(false), 300);
          }}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} size="small" />
              ))}
            </Box>
          )}
          label="Ämnen"
        >
          <MenuItem value="" disabled>
            <em>Välj ämnen</em>
          </MenuItem>
          <MenuItem
            value="most-popular"
            onClick={() => setSelectedSubjects([])}
            sx={{
              fontWeight: selectedSubjects.length === 0 ? "bold" : "normal",
            }}
          >
            <Checkbox checked={selectedSubjects.length === 0} />
            <ListItemText primary="Mest populära" />
          </MenuItem>
          {subjects.map((subject) => (
            <MenuItem
              key={subject.name}
              value={subject.name}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Checkbox checked={selectedSubjects.includes(subject.name)} />
              <Box sx={{ mr: 1, display: "flex", alignItems: "center" }}>
                {subject.icon}
              </Box>
              <ListItemText primary={subject.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  return (
    <List>
      <ListItem
        button
        selected={selectedSubjects.length === 0}
        onClick={() => setSelectedSubjects([])}
        sx={{ ...listItemStyles }}
      >
        <ListItemIcon sx={listItemIconStyles}>
          {selectedSubjects.length === 0 ? (
            <CheckCircleIcon
              sx={{ color: lighten(theme.palette.success.main, 0.2) }}
            />
          ) : (
            <ThumbUpOffAltIcon />
          )}
        </ListItemIcon>
        <ListItemText primary="Mest populära" sx={listItemTextStyles} />
      </ListItem>

      {visibleSubjects.map((subject) => (
        <ListItem
          button
          key={subject.name}
          selected={selectedSubjects.includes(subject.name)}
          onClick={() => {
            setIsLoading(true);
            setSelectedSubjects((prev) => {
              if (prev.includes(subject.name)) {
                return prev.filter((s) => s !== subject.name);
              } else {
                return [...prev, subject.name];
              }
            });
            setTimeout(() => setIsLoading(false), 300);
          }}
          sx={{ ...listItemStyles }}
        >
          <ListItemIcon sx={listItemIconStyles}>
            {selectedSubjects.includes(subject.name) ? (
              <CheckCircleIcon sx={{ color: "success.main" }} />
            ) : (
              subject.icon
            )}
          </ListItemIcon>
          <ListItemText primary={subject.name} sx={listItemTextStyles} />
        </ListItem>
      ))}
      {subjects.length > 10 && (
        <ListItem
          button
          onClick={() => setShowAllSubjects(!showAllSubjects)}
          sx={{
            ...listItemStyles,
            color: "#94a3b8",
          }}
        >
          <ListItemIcon sx={listItemIconStyles}>
            <MoreHorizIcon sx={{ color: "#94a3b8" }} />
          </ListItemIcon>
          <ListItemText
            primary={showAllSubjects ? "Visa färre" : "Visa mer"}
            sx={{
              ...listItemTextStyles,
              "& .MuiTypography-root": {
                ...listItemTextStyles["& .MuiTypography-root"],
                color: "#94a3b8",
              },
            }}
          />
        </ListItem>
      )}
    </List>
  );
};

export const GradeLevels = ({
  selectedGrade,
  setSelectedGrade,
  selectedGrades,
  setSelectedGrades,
  setIsLoading,
  styles,
  selectedSubjects,
  theme,
  selectedSubject,
  filteredItems,
  bankType,
  lessonTypeFilter = false,
  selectedLessonTypes = [],
  setSelectedLessonTypes = () => {},
  quizTypeFilter = false,
  selectedQuizTypes = [],
  setSelectedQuizTypes = () => {},
  compact = false,
}) => {
  const quizTypeOptions = [
    { display: "Flervalsfrågor", value: "multipleChoice" },
    { display: "Sant eller falskt", value: "true-or-false" },
    { display: "Fyll i lucknan", value: "fill-in-the-blank" },
    { display: "Prov", value: "exam" },
    { display: "Nutidsfrågor", value: "current-events" },
  ];

  const lessonTypeOptions = [
    "Läsförståelse",
    "Faktatext",
    "Instruerande text",
    "Förklarande text",
    "Argumenterande text",
    "Beskrivande text",
    "Jeopardy",
    "Tidslinjer",
    "Escape Room",
    "Bygg tidslinjer",
    "Rollkort",
    "Fiktiva dagböcker",
    "Lektionsplan",
    "Litteraturskolan",
    "Fiktiva brev",
    "Historisk person",
    "Krönika",
    "Recension",
    "På spåret",
    "Glosor i lådor",
    "Veckans ord",
    "Tungvrickare",
    "Grammatiklektion",
    "Idiomatiska uttr.",
    "Fiktiva nyhetsredaktionen",
    "Mystiska bilden",
    "Hitta orden",
    "Bilda ordet",
    "Skrivlektion",
    "Forts. berättelsen",
    "Berättande text",
    "Grej of the day",
    "Konversation",
    "Intervju",
    "Argumentera",
    "Generera PowerPoint",
    "Tankekartor",
  ];

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 48 * 8 + 8,

        width: 250,
      },
    },
  };

  if (compact) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {/* Compact Grade Level Filter */}
        <FormControl fullWidth>
          <InputLabel>Årskurser</InputLabel>
          <Select
            multiple
            value={selectedGrades}
            onChange={(e) => {
              setIsLoading(true);
              setSelectedGrades(e.target.value);
              setTimeout(() => setIsLoading(false), 300);
            }}
            renderValue={(selected) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip key={value} label={value} size="small" />
                ))}
              </Box>
            )}
            label="Årskurser"
          >
            {gradeGroups.map((grade) => (
              <MenuItem key={grade} value={grade}>
                <Checkbox checked={selectedGrades.includes(grade)} />
                <ListItemText primary={grade} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Compact Lesson Type Filter */}
        {lessonTypeFilter && (
          <FormControl fullWidth>
            <InputLabel>Typ av lektion</InputLabel>
            <Select
              multiple
              value={selectedLessonTypes}
              onChange={(e) => {
                setSelectedLessonTypes(e.target.value);
                setIsLoading(true);
                setTimeout(() => setIsLoading(false), 300);
              }}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} size="small" />
                  ))}
                </Box>
              )}
              label="Lektionstyp"
            >
              {lessonTypeOptions.map((type) => (
                <MenuItem key={type} value={type}>
                  <Checkbox checked={selectedLessonTypes.indexOf(type) > -1} />
                  <ListItemText primary={type} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {/* Compact Quiz Type Filter */}
        {quizTypeFilter && (
          <FormControl fullWidth>
            <InputLabel>Quiztyp</InputLabel>
            <Select
              multiple
              value={selectedQuizTypes}
              onChange={(e) => {
                setSelectedQuizTypes(e.target.value);
                setIsLoading(true);
                setTimeout(() => setIsLoading(false), 300);
              }}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => {
                    const option = quizTypeOptions.find(
                      (opt) => opt.value === value,
                    );
                    return (
                      <Chip key={value} label={option?.display} size="small" />
                    );
                  })}
                </Box>
              )}
              label="Quiztyp"
            >
              {quizTypeOptions.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  <Checkbox
                    checked={selectedQuizTypes.indexOf(type.value) > -1}
                  />
                  <ListItemText primary={type.display} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {/* Items counter */}
        <Box sx={{ mt: 1 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {filteredItems.length} {bankType} hittades
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ mb: 3, display: "flex", gap: 3 }}>
        {/* Inside the GradeLevels component, update the Box content */}
        {gradeGroups.map((grade) => (
          <Box
            key={grade}
            onClick={() => {
              setIsLoading(true);
              setSelectedGrades((prev) => {
                if (prev.includes(grade)) {
                  return prev.filter((g) => g !== grade);
                } else {
                  return [...prev, grade];
                }
              });
              setTimeout(() => setIsLoading(false), 300);
            }}
            sx={{
              ...styles.freshBox,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 2,
              width: "auto",
              backgroundColor: `${alpha(theme.palette.text.secondary, 0.02)}`,
              borderRadius: "12px",
              padding: "10px",
              paddingLeft: "15px",
              paddingRight: "15px",
              position: "relative", // Added for checkmark positioning
              ...(selectedGrades.includes(grade) && {
                border: `1px solid ${theme.palette.primary.main}`,
              }),
              "&:hover": {
                border: `1px solid ${theme.palette.primary.main}`,
                ...(selectedGrades.includes(grade) && {
                  border: `1px solid ${theme.palette.primary.main}`,
                }),
              },
            }}
          >
            {selectedGrades.includes(grade) && (
              <CheckCircleIcon
                sx={{
                  position: "absolute",
                  bottom: -8,
                  right: -8,
                  color: theme.palette.primary.main,
                  backgroundColor: theme.palette.background.paper,
                  borderRadius: "50%",
                  display: "none",
                }}
              />
            )}
            {selectedGrades.includes(grade) ? (
              <CheckCircleIcon sx={{ color: "primary.main" }} />
            ) : (
              <RadioButtonUncheckedIcon sx={{ color: "text.secondary" }} />
            )}
            <Typography
              className="grade-text"
              sx={{
                fontWeight: 600,
                transition: "all 0.3s ease",
                flex: 1,
              }}
            >
              {grade === "Nationella provet"
                ? "NP"
                : grade === "Gymnasiet"
                  ? "Gymn"
                  : grade}
            </Typography>
          </Box>
        ))}
        {lessonTypeFilter && (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <FormControl
              sx={{
                minWidth: 200,
                borderRadius: "4px",

                "& .MuiOutlinedInput-root": {
                  borderRadius: "4px",

                  "& fieldset": {
                    borderRadius: "8px",
                    borderColor: (theme) =>
                      `${alpha(theme.palette.text.secondary, 0.07)}`,
                  },
                  "&:hover fieldset": {
                    borderColor: (theme) => theme.palette.primary.main,
                  },
                },
              }}
            >
              <InputLabel>Typ av lektion</InputLabel>
              <Select
                multiple
                value={selectedLessonTypes}
                onChange={(e) => {
                  setSelectedLessonTypes(e.target.value);
                  setIsLoading(true);
                  setTimeout(() => setIsLoading(false), 300);
                }}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
                label="Lektionstyp"
                sx={{ borderRadius: "8px" }}
              >
                {lessonTypeOptions.map((type) => (
                  <MenuItem key={type} value={type} sx={styles.menuItemStyle}>
                    <Checkbox
                      checked={selectedLessonTypes.indexOf(type) > -1}
                    />
                    <ListItemText primary={type} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
        {quizTypeFilter && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mt: lessonTypeFilter ? 2 : 0,
            }}
          >
            <FormControl
              sx={{
                minWidth: 200,
                borderRadius: "4px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "4px",
                  "& fieldset": {
                    borderRadius: "8px",
                    borderColor: (theme) =>
                      `${alpha(theme.palette.text.secondary, 0.07)}`,
                  },
                  "&:hover fieldset": {
                    borderColor: (theme) => theme.palette.primary.main,
                  },
                },
              }}
            >
              <InputLabel>Quiztyp</InputLabel>
              <Select
                multiple
                value={selectedQuizTypes}
                onChange={(e) => {
                  setSelectedQuizTypes(e.target.value);
                  setIsLoading(true);
                  setTimeout(() => setIsLoading(false), 300);
                }}
                renderValue={(selected) =>
                  selected
                    .map(
                      (value) =>
                        quizTypeOptions.find((opt) => opt.value === value)
                          ?.display,
                    )
                    .join(", ")
                }
                MenuProps={MenuProps}
                label="Quiztyp"
                sx={{ borderRadius: "8px" }}
              >
                {quizTypeOptions.map((type) => (
                  <MenuItem
                    key={type.value}
                    value={type.value}
                    sx={styles.menuItemStyle}
                  >
                    <Checkbox
                      checked={selectedQuizTypes.indexOf(type.value) > -1}
                    />
                    <ListItemText primary={type.display} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
      </Box>

      {/* Lesson type dropdown */}

      <Box sx={{ display: "block", mt: 2 }}>
        <Typography
          variant="body1"
          sx={{
            mb: 2,
            color: "text.secondary",
            fontWeight: 400,
          }}
        >
          {selectedSubjects.length > 0 &&
            selectedGrades.length > 0 &&
            `Visar ${bankType} för ${selectedSubjects.join(", ")} för ${selectedGrades.join(", ")}${
              selectedLessonTypes.length > 0
                ? ` av typen ${selectedLessonTypes.join(", ")}`
                : ""
            }`}
          {selectedSubjects.length > 0 &&
            selectedGrades.length === 0 &&
            `Visar ${bankType} för ${selectedSubjects.join(", ")}${
              selectedLessonTypes.length > 0
                ? ` av typen ${selectedLessonTypes.join(", ")}`
                : ""
            }`}
          {selectedSubjects.length === 0 &&
            selectedGrades.length > 0 &&
            `Visar mest populära ${bankType} för ${selectedGrades.join(", ")}${
              selectedLessonTypes.length > 0
                ? ` av typen ${selectedLessonTypes.join(", ")}`
                : ""
            }`}
          {selectedSubjects.length === 0 &&
            selectedGrades.length === 0 &&
            `Visar mest populära ${bankType}${
              selectedLessonTypes.length > 0
                ? ` av typen ${selectedLessonTypes.join(", ")}`
                : ""
            }`}
          {` (${filteredItems.length} st)`}
        </Typography>
      </Box>
    </>
  );
};
